module.exports = __webpack_public_path__ + "img/antibiogo-logo-symbol.4df48009.svg";